/**
 * OIN catalog search POST URL. Dev uses the Vite proxy (`/api` → local server).
 * Production defaults to the idaxis host; override with `VITE_OIN_SEARCH_URL`.
 */
export function getOinSearchUrl() {
  const fromEnv = typeof import.meta !== "undefined" && import.meta.env?.VITE_OIN_SEARCH_URL;
  if (fromEnv) return String(fromEnv).trim();
  if (typeof import.meta !== "undefined" && import.meta.env?.DEV) return "/api/idp/okta/oin-search";
  return "https://idwiz.idaxis.id/api/idp/okta/oin-search";
}
